'use strict';

// Define 'forms' namespace
if (!('forms' in window)) window['forms'] = {};

/***********************
 * Global onload event *
 ***********************/

$(function() {
    $('body').on('click', '.form-ajax-submit', function (e) {
        e.preventDefault();

        forms.ajaxSubmit(e);
    });

    setTimeout(function() {
        // Add name attribute to the form in debugbar so we can filter it out.
        $('.phpdebugbar-openhandler-actions form').attr('name', 'phpdebugbar_form');

        // All other forms (because newsletter and search can be on the same page as other forms)
        let inputs = $('body form').not("[name='info_form'],  [name='phpdebugbar_form']").find(':input[required]:visible');

        $.each(inputs, function (index, input) {
            $(input).bind('input', function () {
                let values = [];
                $.each(inputs, function (nestedIndex, nestedInput) {
                    values.push(nestedInput.value);
                });

                // If there is no empty values, enable the button
                if (!values.includes('')) {
                    forms.enableSubmit();
                } else {
                    forms.disableSubmitNoSpinner();
                }
            });
        });

    }, 300);
});

/*********************************
 * Methods (in "forms" namespace) *
 *********************************/

forms.ajaxSubmit = function (e) {
    let formButton = $(e.target);
    let form = $(formButton).closest('form');
    let formHtmlElement = form[0];
    let formRow = form.find('#form-row');
    let confirmationRow = form.find('#confirmation-row');
    let formErrorSpan = form.find('span[data-failure]');
    let failureMessage = formErrorSpan.data('failure');

    // clear potential previously set validation errors
    forms.clearValidationErrors(form);

    // show spinning loader
    $('#envelope-icon').addClass('d-none');
    $('#spinning-loader').removeClass('d-none');

    // Get the formData for this form. (Doing this in the AJAX call results in an Illegal Invocation error, that's why it's done here)
    let formData = new FormData(formHtmlElement);

    // Submit the form through Statamic using AJAX
    $.ajax({
        url: formHtmlElement.action,
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false,
    })
      .done(response => {
          if (response.success) {
              confirmationRow.removeClass('d-none');
              formRow.addClass('d-none');
              $("#sendPureContactForm").hide();
              $(".formButton").hide();
              $('html, body').stop(true, true).animate({
                  scrollTop: (confirmationRow.offset().top - 70)
              }, 500, 'linear');
          } else {
              formErrorSpan.html(failureMessage);
              formErrorSpan.show();
          }
      })
      .fail(response => {
          if (response.status === 404) {

          } else {
              $.each(response.responseJSON.error, function (formFieldName, validationErrorText) {
                  let formField = form.find(`[name=${formFieldName}]`);
                  let formFieldValidationSpan = form.find(`span.${formFieldName}`);

                  formFieldValidationSpan.html(validationErrorText);
                  formFieldValidationSpan.show();
                  formField.addClass('is-invalid');
              });

              forms.enableSubmit(e);
          }
      });
};

forms.hideToggleableContent = function () {
    let toggleableContentForm = $('div[data-js="form-toggleable-content"]');
    if (toggleableContentForm.is(':visible')) {
        toggleableContentForm.hide();
    }
};

forms.removeCollapse = function () {
    if ($('.split-blocks .collapse, .split-blocks .collapse-link').is(':visible')) {
        $('.split-blocks .collapse, .split-blocks .collapse-link').remove();
    }

    if ($('#newsletter_form').is(':visible')) {
        $('[rel="gaUrl"]').attr('href', 'https://' + document.location.host + '/en/newsletter-result');
    }
}

forms.enableSubmit = function (e) {
    // remove spinning loader and enable the button
    $('#spinning-loader').addClass('d-none');
    $('#envelope-icon').removeClass('d-none');

    // if e is undefined find the closest submit button to the spinning-loader.
    if (e === undefined) {
        let button = $(".form-ajax-submit");
        button.prop('disabled', false);
        button.removeClass('btn-disabled');
    } else {
        $(e.target).prop('disabled', false);
    }
}

forms.disableSubmit = function (e) {
    // show spinning loader and disable the button
    $('#envelope-icon').addClass('d-none');
    $('#spinning-loader').removeClass('d-none');
    $(e.target).prop('disabled', true);
}

forms.disableSubmitNoSpinner = function (e) {
    // if e is undefined find the closes submit button to the spinning-loader.
    if (e === undefined) {
        let button = $(".form-ajax-submit");
        button.prop('disabled', true);
        button.addClass('btn-disabled');
    } else {
        $(e.target).prop('disabled', true);
        $(e.target).addClass('btn-disabled');
    }
}

forms.clearValidationErrors = function (form) {
    form.find('.form-group').each(function (index, formGroup) {
        let formField = $(formGroup).find('.form-control');
        formField.removeClass('is-invalid');

        let formInvalidFeedbackSpans = $(formGroup).find('.invalid-feedback');
        formInvalidFeedbackSpans.hide();
        formInvalidFeedbackSpans.empty();
    });
};